import React from "react";
import useTranslation from "next-translate/useTranslation";
import { getModeIcon, getModeNameCapitalFirst } from "../../../util/util";
import { FaSignal } from "react-icons/fa";
import Link from "next/link";
import Medal from "../../../components/Medal";

import { FaGraduationCap } from "react-icons/fa";
// import { FaStar } from 'react-icons/fa';
import { FaTrophy } from "react-icons/fa";
import {
  LeagueNames,
  LEAGUE_IDS,
  LEAGUE_LIMITS,
  LEAGUE_NAME_PLACEMENT,
  MIN_GAME_NR_PER_LEAGUE,
} from "@chesshotel/constants";

import InfoCard from "./InfoCard";
import { useSignIn } from "@/redux/signIn";
// import { HasToolTip, ToolTip } from "@/components/ui/ToolTip";

export default function LeagueCard({ modeId, leagueScore, isDesktop }) {
  const { t } = useTranslation("common");
  const { t: lobbyT } = useTranslation("lobby");
  const { loading } = useSignIn();

  if (modeId === null || leagueScore === null) {
    return <div className="h-16 mb-3 "></div>;
  }

  const rank = leagueScore?.rank;
  const leagueName = leagueScore?.leagueName;
  const points = leagueScore?.points;
  const elo = leagueScore?.elo;
  const gameNr = leagueScore?.gameNr;

  // function getIcon() {
  //   return (
  //     <div
  //       className="flex items-center justify-center
  //     mt-3 mb-2.5 md:mt-5 ml-2 mr-1 h-12 w-12
  //     text-lg md:w-16 md:h-16 md:text-2xl rounded-full bg-altgray-200"
  //     >
  //       {getModeIcon(modeId)}
  //     </div>
  //   );
  // }

  function getMedal() {
    // return <SquareMedal rank={rank} leagueName={leagueName} />;
    return (
      <Link className="hover:brightness-[1.07]" href={`/leagues/${modeId}`}>
        {/* <Medal
            title="RANK"
            rank={rank}
            leagueName={leagueName}
            size={isDesktop ? "medium" : "small"}
          /> */}
        {/* <MedalImage rank={rank} leagueName={leagueName} /> */}
        <Medal
          title={"RANK"}
          rank={rank}
          leagueName={leagueName}
          size={isDesktop ? "smallMedium" : "small"}
        />
      </Link>
    );
  }

  function renderPromotionProc() {
    const nextLeagueId = LEAGUE_IDS[leagueName] + 1;
    const leagueLimit = LEAGUE_LIMITS[nextLeagueId];
    if (!leagueLimit) {
      return;
    }
    const gameNrProc = Math.min(gameNr / MIN_GAME_NR_PER_LEAGUE, 1) * 50;
    const eloLimitProc = (elo * 50) / leagueLimit;
    const nextLeagueProc = Math.min(Math.round(gameNrProc + eloLimitProc), 99);
    return (
      <span className="has-tooltip">
        <span className="tooltip">{t("League promotion")}</span>
        <div className="flex items-center ml-4">
          <div className="flex items-center justify-center flex-shrink-0 text-sm text-red-400 rounded-full md:text-base">
            <FaTrophy />
          </div>

          {/* <div className="bg-altgray-100 w-28 md:w-24 rounded ml-1.5 md:ml-2">
            <div
              className={`flex text-xs items-center h-full overflow-hidden rounded bar-anim
            ${
              nextLeagueProc === 0 ? "bg-opacity-0" : "bg-red-100 justify-end"
            }        
            `}
              style={{
                width: nextLeagueProc + "%",
              }}
            >
              <div className="flex py-0 mx-1 font-semibold">
                {nextLeagueProc}%
              </div>
            </div>
          </div> */}

          <div className="flex flex-col ml-1.5 md:ml-1.5">
            <div className="flex items-center">
              <div className="text-xs select-none md:text-md">
                {nextLeagueProc}%
              </div>
            </div>
          </div>
        </div>
      </span>
    );
  }

  // function renderBar() {
  //   let val: any, widthVal: number, title: string;

  //   // if (leagueName === LEAGUE_NAME_PLACEMENT) {
  //   //   title = t("Placement games");
  //   //   val = gameNr ? gameNr : 0;
  //   //   widthVal = (val * 100) / 5;
  //   // } else {
  //   title = t("League promotion");
  //   const nextLeagueId = LEAGUE_IDS[leagueName] + 1;
  //   const leagueLimit = LEAGUE_LIMITS[nextLeagueId];
  //   const gameNrProc = Math.min(gameNr / MIN_GAME_NR_PER_LEAGUE, 1) * 50;
  //   const eloLimitProc = (elo * 50) / leagueLimit;
  //   widthVal = Math.min(Math.round(gameNrProc + eloLimitProc), 99);
  //   val = widthVal + "%";
  //   // }

  //   return isDesktop ? (
  //     <div className="flex flex-col justify-center w-3/5">
  //       <div className="whitespace-nowrap font-normal text-xs mt-2 mb-0.5">
  //         {title}
  //       </div>
  //       <div className="flex items-center justify-center w-full">
  //         <div className="flex w-full">
  //           <div
  //             className={`bg-altgray-100 w-full rounded-md  my-0.5 font-semibold`}
  //           >
  //             <div
  //               className={`flex items-center h-full overflow-hidden ${
  //                 val === 0 ? "bg-opacity-0" : "bg-red-300 justify-end"
  //               } rounded-md`}
  //               style={{
  //                 width: widthVal + "%",
  //               }}
  //             >
  //               <div
  //                 className={`mr-1  text-xs ${
  //                   val === 0 ? "text-altgray-600 ml-1" : "text-red-50"
  //                 }`}
  //               >
  //                 {val}
  //               </div>
  //             </div>
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   ) : (
  //     <div className="flex items-center ml-3 md:ml-4 md:mt-0 ">
  //       <div
  //         className="flex items-center justify-center flex-shrink-0 text-sm text-red-400 rounded-full // md:text-lg"
  //       >
  //         <FaTrophy />
  //       </div>
  //       <div className={`bg-altgray-200 w-[80px] rounded-md ml-1.5 md:ml-2`}>
  //         <div
  //           className={`flex text-xs font-semibold items-center h-full justify-end
  //                       overflow-hidden bg-red-100 rounded-md`}
  //           style={{ width: widthVal + "%" }}
  //         >
  //           <div className="mr-1">{val}</div>
  //         </div>
  //       </div>
  //     </div>
  //   );
  // }

  function renderPlacementGames() {
    const placement = gameNr ? gameNr : 0;
    const placementWidth = placement ? (placement * 100) / 5 : 20;

    return (
      <div className="flex">
        <span className="has-tooltip">
          <span className="tooltip">{lobbyT("Placement games")}</span>

          <div className="flex items-center ml-3 md:ml-4 md:mt-0 ">
            <div className="flex items-center justify-center text-sm text-red-400 rounded-full md:text-lg">
              <FaGraduationCap />
            </div>

            {true ? (
              <div className="flex flex-col ml-1.5 md:ml-1.5">
                <div className="flex items-center">
                  <div className="text-xs select-none md:text-md">
                    {placement} <span className="text-altgray-500"> / 5 </span>
                  </div>{" "}
                </div>
              </div>
            ) : (
              <div className="relative bg-altgray-100 w-28 md:w-24 rounded ml-1.5 md:ml-2">
                <div
                  className={`flex text-xs items-center h-full overflow-hidden rounded bar-anim
            ${
              placement === 0 ? "bg-opacity-0" : "bg-red-100 justify-end"
            }        
            `}
                  style={{
                    width: placementWidth + "%",
                  }}
                >
                  <div className="flex py-0 mx-1 ">{placement} </div>
                </div>
                <div className="absolute top-0 text-xs right-1 text-altgray-500">
                  5
                </div>
              </div>
            )}
            {/* <div className="ml-1 text-xs text-altgray-500">5</div> */}
          </div>
        </span>
      </div>
    );
  }

  function renderLeagueInfo() {
    return (
      <div className="flex items-center w-full">
        <span className="has-tooltip">
          <span className="tooltip">{t("Rating")}</span>
          <div className="flex items-center">
            <div className="flex items-center justify-center flex-shrink-0 text-sm text-red-400 rounded-full md:text-lg">
              <FaSignal />
            </div>
            <div className="flex flex-col ml-1.5 md:ml-1">
              <div className="flex items-center">
                <div className="text-xs select-none md:text-md">{elo}</div>{" "}
              </div>
            </div>
          </div>
        </span>

        {/* <span className="has-tooltip">
          <span className="tooltip">{t("Points")}</span>
          <div className="flex items-center ml-4">
            <div
              className="flex items-center justify-center flex-shrink-0 text-sm text-red-400 rounded-full md:text-lg"
            >
              <FaStar />
            </div>
            <div className="flex flex-col ml-1.5 md:ml-1">
              <div className="flex items-center">
                <div className="text-xs font-semibold select-none md:text-md">
                  {points}
                </div>
              </div>
            </div>
          </div>
        </span> */}

        {leagueName === LEAGUE_NAME_PLACEMENT
          ? renderPlacementGames()
          : renderPromotionProc()}
      </div>
    );
  }

  if (loading) {
    return <InfoCard />;
  }

  if (leagueName === LeagueNames.PLACEMENT) {
    return (
      <InfoCard
        title={t("{{name}} league", {
          name: getModeNameCapitalFirst(modeId, t),
        })}
        icon={getModeIcon(modeId)}
      >
        {renderLeagueInfo()}
      </InfoCard>
    );
  }

  return (
    <InfoCard
      title={`${getModeNameCapitalFirst(modeId, t)} ${t(
        leagueName + " league"
      )}`}
      medal
      icon={getMedal()}
    >
      {renderLeagueInfo()}
    </InfoCard>
  );

  // return (
  //   <div
  //     className="flex w-full p-3 pb-3 mt-1 border-b // md:mt-0 md:pb-3 md:p-4 md:h-auto rounded-t-xl border-altgray-100 md:bg-white "
  //   >
  //     <div className="flex items-center justify-center w-full overflow-hidden">
  //       <div className="flex w-full space-x-2 md:space-x-4">
  //         <div className="flex mx-1">{getMedal()}</div>
  //         <div className="flex flex-col w-full md:w-4/5 pt-2.5 md:pt-6 pl-1 md:pl-0">
  //           <div
  //             className="flex w-full text-altgray-700 items-center space-x-1 pb-1.5 md:pb-2.5 rounded-t-xl
  //             font-semibold text-xl
  //           border-altgray-100"
  //           >
  //             <div className="flex space-x-1">
  //               <div>{getModeNameCapitalFirst(modeId)}</div>
  //               <div>{t(leagueName + " league")}</div>
  //             </div>
  //           </div>
  //           {renderLeagueInfo()}
  //         </div>
  //       </div>
  //       {/* <div className="absolute bottom-0 right-0 h-8 rounded-br-lg rounded-tl-md bg-altgray-100 w-72">
  //         {" "}
  //       </div> */}
  //     </div>
  //   </div>
  // );
}
